export const getJsData = () => JSON.parse(window.jsPassthroughData);
